<template>
  <div class="entry-wrapper">
    <div class="entry-inner container-wrapper">
      <div class="left-tree">
        <tree-list
          :topicCategorys = "topicCategorysItem"
          >
          <span class="tree-title-style">专题分类</span>
        </tree-list>
      </div>
      <div class="right-main" v-if="itemList.resulter">
        <bread-crumb :totalItems="itemList.resulter.hit"></bread-crumb>
        <div class="top-list-area">
          <div class="topic-list-title">
            <div class="text-icon">地区分类：</div>
            <div class="btn-export" @click="isShowAll = !isShowAll" v-if="areaCategorysItem.length > 15"><span class="iconfont showAll" v-if="!isShowAll">收起&nbsp;&nbsp;&#xe661;</span><span class="iconfont showAll" v-if="isShowAll">展开&nbsp;&nbsp;&#xe63c;</span></div>
          </div>
          <div class="area-list" :class="{showAllArea: isShowAll}">
            <div class="all-area area-item"  :class="{select : currentIndex == -2}" @click="handleCurrentSelect(-2, '')">全部</div>
            <div v-for="(item, index) of areaCategorysItem"
              :key="index"
              class="area-item"
              :class="{select : currentIndex == index}"
              @click="handleCurrentSelect(index, item.value)"
            >
              {{item.value}}
            </div>
          </div>
        </div>
        <div class="item-list" v-if="itemList.resulter.hit">
          <div class="item" v-for="(item, index) of JSON.parse(itemList.resulter.results)" :key="index">
            <div class="item-title">
              <div class="title" @click="handleItemRead(item.Id)" :title="item.Title">{{(index+1) + (itemList.resulter.pageSize) * (itemList.resulter.curPage-1)}}. {{item.Title}}</div>
              <span class="downing" @click="handleItemDown(item.Id)">下载</span>
              <span class="reading" @click="handleItemRead(item.Id)">阅读</span>
            </div>
            <div class="item-message">
              <div class="message-1">来&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;源：<span :title="item.BookTitle" @click="handleDetail(item.BookID)">{{item.BookTitle}}</span></div>
              <div class="message-2" v-if="item.Province || item.City ||item.County">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;区：
                <span :title="(item.Province || '') + (item.City || '') + (item.County || '')">{{item.Province}}{{item.City}}{{item.County}}</span>
              </div>
              <div class="message-3" v-if="item.Publisher">出版单位：<span :title="item.Publisher">{{item.Publisher}}</span></div>
              <div class="message-4" v-if="item.Date">出版时间：<span :title="item.Date">{{item.Date}}</span></div>
              <div class="message-5" v-if="item.Editorial">编纂单位：<span :title="item.Editorial">{{item.Editorial}}</span></div>
            </div>
            <p class="item-content" v-if="item.Content">{{item.Content}}</p>
          </div>
        </div>
        <div class="searchWarn" v-else>
          <i class="wf-icon icon-information"></i>
            没有命中记录，请重试或修改检索表达式
        </div>
        <Paganition
          v-if="this.itemList.resulter.totalPage > 1"
          :total= "this.itemList.resulter.hit"
          :currentPage= itemList.resulter.curPage
          :pageSize= itemList.resulter.pageSize
          :totalPage= itemList.resulter.totalPage
          @size-change="handleUpdateData()"
          @handleCurrentChangeSub="handleCurrentChangeSub"
          name="pagination"
        >
        </Paganition>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Paganition from '../../components/Pagination/Pagination'
import TreeList from '../../components/treeList/TreeList'
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb'
import {READ_URL, RESOURCE_TYPE_ITEM_READ, LOGIN_IN_URL, RESOURCE_TYPE_ITEM_DOWN} from '../../assets/constant'
export default {
  name: 'Entry',
  data () {
    return {
      opt: {
        fq: [],
        pageNo: 1,
        pageSize: 10,
        query: '',
        searchType: ''
      },
      query: {
        CategoryA: '',
        CategoryB: '',
        totalIndex: '',
        Province: '',
        pageNo: 1
      },
      // 上一个节点的信息
      lastTreeNodeId: 0,
      lastSubNodes: 0,
      totalIndex: 0,
      isShowAll: true,
      currentIndex: this.$route.query.currentIndex || -2,
      curPage: 1
    }
  },
  components: {
    Paganition,
    TreeList,
    BreadCrumb
  },
  mounted() {
    if (this.$loginAuthentication.intercept(0)) {
      this._reqRouterQuery()
      // this._replaceRouterParam(this.opt)
      this.$store.dispatch('getTopicCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['CategoryA', 'CategoryB'] })
      this.$store.dispatch('getAreaCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['Province'], fq: this._initTopicCategory() })
      this.$store.dispatch('getItemList', this.opt)
    }
  },
  methods: {
    // 跳转志书详情页
    async handleDetail(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({
          path: '/detail',
          query: { BookID: id }
        })
      }
    },
    // 条目下载
    async handleItemDown(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        // 3 条目下载
        this.$store.dispatch('savSourceType', 3)
        if (this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_DOWN);
        } else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    // 条目阅读
    async handleItemRead(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$store.dispatch('savSourceType', 1)
        if (this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_ITEM_READ);
        } else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.location.href
        }
      }
    },
    _reqRouterQuery () {
      const CategoryA = this.$route.query.CategoryA || ''
      const CategoryB = this.$route.query.CategoryB || ''
      const Province = this.$route.query.Province || ''
      const pageNo = this.$route.query.pageNo || 1
      const query = this.$route.query.query || ''
      // debugger
      // this.currentIndex = this.$route.query.currentIndex || -2
      const fq = []
      let cat = ''
      if (CategoryB !== '') {
        cat = `CategoryB:${CategoryA}#${CategoryB}`
        fq.push(cat)
      }
      if (CategoryA !== '' && CategoryB === '') {
        cat = `CategoryA:${CategoryA}`
        fq.push(cat)
      }
      if (Province !== '') {
        cat = `Province:${Province}`
        fq.push(cat)
      }
      this.opt.fq = fq
      this.opt.pageNo = pageNo || 1
      this.opt.query = query || ''
      this.opt.core = 'LocalChronicleItemEdu'
    },
    _replaceRouterParam (query) {
      const CategoryA = this.$route.query.CategoryA || ''
      const CategoryB = this.$route.query.CategoryB || ''
      const Province = this.$route.query.Province || ''
      const totalIndex = this.$route.query.totalIndex || ''
      const pageNo = this.$route.query.pageNo || 1
      const currentIndex = this.$route.query.currentIndex
      // const currentIndex = this.$route.query.currentIndex || -2
      this.$router.replace({path: 'entry',
        query: {
          CategoryA: query.CategoryA || CategoryA,
          CategoryB: query.CategoryB || CategoryB,
          totalIndex: query.totalIndex || totalIndex,
          Province: query.Province || Province,
          pageNo: query.pageNo || pageNo,
          currentIndex: currentIndex
          // currentIndex: currentIndex
        }})
    },
    async handleCurrentSelect(index, value) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.currentIndex = index
        const CategoryA = this.$route.query.CategoryA
        const CategoryB = this.$route.query.CategoryB
        const totalIndex = this.$route.query.totalIndex
        // this.currentIndex = index
        this.$router.replace({
          path: 'entry',
          query: {
            CategoryA: CategoryA || '',
            CategoryB: CategoryB || '',
            totalIndex: totalIndex || '',
            Province: value,
            currentIndex: index
          }
        })
      }
    },
    _initTopicCategory () {
      const CategoryA = this.$route.query.CategoryA || ''
      const CategoryB = this.$route.query.CategoryB || ''
      const fq = []
      let cat = ''
      if (CategoryB !== '') {
        cat = `CategoryB:${CategoryA}#${CategoryB}`
        fq.push(cat)
      }
      if (CategoryA !== '' && CategoryB === '') {
        cat = `CategoryA:${CategoryA}`
        fq.push(cat)
      }
      // this.opt.fq = fq
      return fq
    },
    // 当前页改变触发
    async handleCurrentChangeSub(val) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.query.pageNo = val
        this._replaceRouterParam(this.query)
      }
    }
  },
  computed: {
    ...mapState(['topicCategorysItem', 'areaCategorysItem', 'itemList', 'userinfo'])
  },
  watch: {
    // 监听主题分类参数
    '$route.query.currentIndex' (val) {
      if (val === undefined) {
        this.currentIndex = -2
      }
    },
    $route: {
      handler: function (val) {
        if (this.$loginAuthentication.intercept(0)) {
          // this.currentIndex = this.$route.query.currentIndex || -2
          this._reqRouterQuery()
          this.$store.dispatch('getItemList', this.opt)
          this.$store.dispatch('getAreaCategoryItem', { core: 'LocalChronicleItemEdu', facetPivot: ['Province'], fq: this._initTopicCategory() })
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.entry-wrapper {
  background: #e9edf0;
  min-height: 800px;
  // padding-bottom: 38px;
  &::after {
    content: "";
    position: absolute;
    background: url("../../assets/imgs/bg-lf.png") no-repeat;
    width: 204px;
    height: 226px;
    top: 680px;
  }
  &::before {
    content: "";
    position: absolute;
    background: url("../../assets/imgs/bg-rt.png") no-repeat;
    width: 204px;
    height: 226px;
    top: 920px;
    right: 0;
  }
  .entry-inner {
    position: relative;
    z-index: 1;
    overflow: hidden;
    background: #fff;
    padding-top: 20px;
  }
}
.top-list-area {
  .btn-export {
    .showAll {
      font-size:13px;
    }
    font-size:13px;
    font-weight:400;
    color:rgba(23,67,165,1);
    line-height:28px;
    text-align: center;
    width:76px;
    height:28px;
    cursor: pointer;
  }
  .area-item {
    height: 35px;
    line-height: 35px;
    margin: 0 5px;
    border-bottom: 1px dotted #EEEEEE;
    float: left;
  }
  .area-list {
    float: left;
    margin-bottom: 14px;
    transition: all 0.3s ease-in-out;
    div {
      cursor: pointer;
      width: 112px;
      text-align: center;
      &:hover {
        color: #1743A5;
        text-decoration-line: underline;
      }
      &.select {
        color: #1743A5;
        text-decoration-line: underline;
      }
    }
    &.showAllArea {
      height: 72px;
      overflow: hidden;
      transition: all .3s ease-in-out;
    }
  }
}
.elipse () {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
 .right-main {
  float: right;
  margin-right: 20px;
  margin-top: 12px;
  width:880px;
  position: relative;
  min-height: 800px;
  padding-bottom: 100px;
  overflow: hidden;
  .searchWarn {
    font-size: 18px;
    text-align: center;
    margin-top: 250px;
  }
  .top-list-area {
    width:896px;
    overflow: hidden;
    background:#f5f8ff;
    margin-right: 20px;
    margin-bottom: 10px;
    .topic-list-title {
      font-weight: bold;
      color: #333333;
      line-height: 32px;
      padding-top: 15px;
      margin-left: 17px;
      margin-bottom: 5px;
      margin-right: 9px;
      overflow: hidden;
      width: 850px;
      .text-icon {
        float: left;
        font-size:14px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:32px;
      }
      .btn-export {
        float: right;
        width:76px;
        background:rgba(239,243,251,1);
        border:1px solid rgba(105,124,164,1);
        border-radius:4px;
      }
    }
  }
  .item-list {
    .item {
      width: 874px;
      padding-top: 15px;
      padding-bottom: 20px;
      border-bottom: 1px dotted #DDDDDD;
    }
    .item-title {
      background: url("../../assets/imgs/item-title-bg.png") no-repeat;
      background-position: left center;
      overflow: hidden;
      height: 30px;
      line-height: 30px;
      overflow: hidden;
      margin-bottom: 20px;
      span {
        float: right;
        width:76px;
        height:28px;
        border-radius:14px;
        text-align: center;
        line-height: 28px;
        color: #1743A5;
        background-color: #F5F8FF;
        margin-left: 10px;
        background:rgba(245,248,255,1);
        border:1px solid rgba(105,124,164,1);
        border-radius:14px;
        cursor: pointer;
        &:hover {
          background:rgba(65,96,165,1);
          color: #FFFFFF;
        }
        &.active {
          background:rgba(65,96,165,1);
          color: #FFFFFF;
        }
      }
      .title {
        height: 28px;
        max-width: 660px;
        padding-left: 25px;
        cursor: pointer;
        &:hover {
          color: #1743a5;
          text-decoration-line: underline;
        }
        .elipse();
        font-size:16px;
        font-weight:bold;
        color:rgba(51,51,51,1);
      }
    }
    .item-message {
      font-size:13px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      overflow: hidden;
      width: 873px;
      div {
        margin-right: 38px;
        &::after {
          content: '';
          height: 100%;
          display: inline-block;
          vertical-align: middle;
        }
        span {
          line-height: 24px;
        }
      }
      div, span {
        display: inline-block;
        vertical-align: middle;
        height: 24px;
      }
      span {
        font-weight:400;
        height: 100%;
      }
      .message-1 {
        width: 260px;
        span {
          cursor: pointer;
          width: 180px;
            .elipse();
            &:hover {
              color: #4160a5;
              text-decoration: underline;
            }
            &.active {
              color:rgba(65,96,165,1);
              text-decoration: underline;
            }
          }
      }
      .message-2 {
        width: 230px;
        span {
          width: 130px;
            .elipse();
          }
      }
      .message-3 {
        span {
          width: 174px;
            .elipse();
          }
      }
      .message-4 {
        width: 260px;
        span {
          width: 180px;
            .elipse();
          }
      }
      .message-5 {
        max-width: 570px;
        span {
          max-width: 485px;
            .elipse();
          }
        }
    }
    .item-content {
      margin-top: 10px;
      max-height: 36px;
      color: #666666;
      line-height: 19px;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}
.left-tree {
  padding: 0 20px;
  padding-bottom: 9000px;
  margin-bottom: -9000px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Entry/Entry.vue